import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "@/pages/LandingPage";
import PrivacyPage from "@/pages/PrivacyPage";
import FeatureDetailPage from "@/pages/FeatureDetailPage";
import PartnersPage from "@/pages/PartnersPage";
import ResourcesPage from "@/pages/ResourcesPage";
import FAQPage from "@/pages/FAQPage";
import VideosPage from "@/pages/VideosPage";
import PodcastPage from "@/pages/PodcastPage";
import DeleteAccountPage from "@/pages/DeleteAccountPage";
import TermsPage from "@/pages/TermsPage";
import BlogPage from "@/pages/BlogPage";
import CookieConsent from "@/components/landing/CookieConsent";
import ScrollToTop from "@/components/landing/ScrollToTop";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/partners" element={<PartnersPage />} />
        <Route path="/resources" element={<ResourcesPage />} />
        <Route path="/faq" element={<FAQPage />} />
        <Route path="/videos" element={<VideosPage />} />
        <Route path="/podcast" element={<PodcastPage />} />
        <Route path="/delete-account" element={<DeleteAccountPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/features/:slug" element={<FeatureDetailPage />} />
      </Routes>
      <CookieConsent />
      <ScrollToTop />
    </BrowserRouter>
  );
}

export default App;
